import { fetchEvents } from "./asyncThunks";

export const fetchEventsBuilder = (builder) => {
  builder.addCase(fetchEvents.fulfilled, (state, action) => {
    state.events.data = action.payload.data.events;
  });
};
